module.exports = __webpack_public_path__ + "static/img/austria.283283f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hotel/austria.jpg
// module id = MDDR
// module chunks = 0